import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export function usePermissions() {
  const { data: getMeData } = useSelector((state) => state.user.getMe);

  const permissions = useMemo(() => {
    if (!getMeData) return [];
    return getMeData.permissions || [];
  }, [getMeData]);

  const isSuperuser = useMemo(() => {
    return getMeData?.is_superuser === true;
  }, [getMeData]);

  const hasPermission = (permission) => {
    if (isSuperuser) return true;
    return permissions.some((p) => p.name === permission || p === permission);
  };

  const hasAnyPermission = (permissionList) => {
    if (isSuperuser) return true;
    return permissionList.some((p) => hasPermission(p));
  };

  const hasAllPermissions = (permissionList) => {
    if (isSuperuser) return true;
    return permissionList.every((p) => hasPermission(p));
  };

  return {
    permissions,
    isSuperuser,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isLoaded: !!getMeData,
  };
}
